export const commentRestrictions = {
  maxReplies: 10,
  maxImages: 10,
  maxPingSuggestions: 5
};
